(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["higado"] && !Shopify.designMode) return;
  try {
    
(function () {
  function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  var RSI = '._rsi-buy-now-button,[class*="_rsi-buy"],[id*="_rsi-buy"],[class*="releasit"] button,button[class*="releasit"],[id*="releasit"] button';
  var RSI_ANY = '[class*="_rsi"],[id*="_rsi"],[class*="releasit"],[id*="releasit"]';

  function init(root) {
    if (!root || root.getAttribute('data-vs-ready')) return;
    root.setAttribute('data-vs-ready', '1');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasIO = 'IntersectionObserver' in window;
    var mode = root.getAttribute('data-vs-mode') || 'releasit';
    var direct = root.getAttribute('data-vs-direct') === '1';
    var box = root.querySelector('[data-vs-buybox]');
    var qtyInput = root.querySelector('[data-vs-qty]');

    /* ---- Pack elegido ---- */
    function selectedQty() {
      var sel = root.querySelector('.vs-pack input:checked');
      var pack = sel ? sel.closest('.vs-pack') : null;
      var q = pack ? parseInt(pack.getAttribute('data-qty'), 10) : NaN;
      return isNaN(q) ? null : q;
    }
    function setQty(input) {
      var q = selectedQty();
      if (!q || !input) return;
      input.value = q;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /* ---- Dónde está el botón que abre el formulario ---- */
    function releasitButton() {
      var b = box && box.querySelector(RSI);
      if (!b) b = document.querySelector(RSI);
      return b;
    }
    function themeButton() {
      var btn = document.querySelector('[data-vs-buy]') ||
                document.querySelector('form[action*="/cart/add"] button[type="submit"]:not([hidden])');
      if (btn && btn.closest('.vs')) return null;
      return btn;
    }
    function scrollTo(el) {
      if (el) el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    }

    /* ---- Botones de la página (barra fija, cierre): abren Releasit o llevan a la compra ---- */
    root.querySelectorAll('[data-vs-cta]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        if (mode === 'dawn') {
          var tb = themeButton();
          if (tb) {
            var form = tb.form || tb.closest('form');
            setQty(form && form.querySelector('input[name="quantity"]'));
            if (direct) { tb.click(); } else { scrollTo(tb); }
          } else {
            scrollTo(document.getElementById('MainContent'));
          }
          return;
        }
        var rb = direct ? releasitButton() : null;
        if (rb) { setQty(qtyInput); rb.click(); }
        else { scrollTo(box); }
      });
    });

    /* ---- Si Releasit no aparece, se muestra un botón propio para no dejar la página sin compra ---- */
    var fallback = root.querySelector('[data-vs-fallback]');
    if (fallback && box) {
      setTimeout(function () {
        if (!box.querySelector(RSI_ANY) && !document.querySelector(RSI)) fallback.hidden = false;
      }, 3500);
    }

    /* ---- Selector de packs: cantidad para Releasit y precios de la barra fija y del cierre ---- */
    var packs = root.querySelectorAll('.vs-pack');
    function syncPack() {
      var sel = root.querySelector('.vs-pack input:checked');
      if (!sel) return;
      var pack = sel.closest('.vs-pack');
      var price = pack.getAttribute('data-price');
      var cmp = pack.getAttribute('data-compare');
      root.querySelectorAll('[data-vs-price]').forEach(function (n) { if (price) n.textContent = price; });
      root.querySelectorAll('[data-vs-compare]').forEach(function (n) { n.textContent = cmp || ''; n.style.display = cmp ? '' : 'none'; });
      setQty(qtyInput);
    }
    if (packs.length) {
      if (!root.querySelector('.vs-pack input:checked')) packs[0].querySelector('input').checked = true;
      packs.forEach(function (p) { p.addEventListener('change', syncPack); });
      syncPack();
    }

    /* ---- Galería: miniaturas que mueven el carrusel ---- */
    var track = root.querySelector('[data-vs-track]');
    var thumbs = root.querySelectorAll('.vs-thumb');
    if (track && thumbs.length) {
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = parseInt(t.getAttribute('data-vs-i'), 10) - 1;
          track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      }, { passive: true });
    }

    /* ---- Barra fija: aparece cuando la tarjeta de compra sale de pantalla ---- */
    var bar = root.querySelector('[data-vs-sticky]');
    var end = root.querySelector('.vs-final');
    if (bar && box && hasIO) {
      var boxIn = true, endIn = false;
      var update = function () { bar.classList.toggle('is-on', !boxIn && !endIn); };
      new IntersectionObserver(function (e) { boxIn = e[0].isIntersecting; update(); }).observe(box);
      if (end) new IntersectionObserver(function (e) { endIn = e[0].isIntersecting; update(); }).observe(end);
    }

    /* ---- Aparición al deslizar ---- */
    if (hasIO && !reduce) {
      root.classList.add('vs-js');
      var sel = '.vs-ing,.vs-steps li,.vs-who>div,.vs-fact,.vs-tablewrap,.vs-faq details,.vs-guarantee-card,.vs-label-photo';
      var items = root.querySelectorAll(sel);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      items.forEach(function (el, i) {
        el.classList.add('vs-reveal');
        el.style.transitionDelay = ((i % 4) * 70) + 'ms';
        io.observe(el);
      });
    }

    /* ---- Contadores animados (solo números simples) ---- */
    var counters = root.querySelectorAll('[data-vs-count]');
    function prepare(el) {
      var txt = (el.textContent || '').trim();
      var m = txt.match(/^([^\d]*)(\d[\d.,]*)(.*)$/);
      if (!m || /[–—-]\s*\d/.test(m[3])) return null;
      var target = parseInt(m[2].replace(/[.,]/g, ''), 10);
      if (isNaN(target)) return null;
      return { pre: m[1], post: m[3], target: target, full: txt };
    }
    function run(el, d) {
      if (reduce) { el.textContent = d.full; return; }
      var t0 = null, dur = 1400;
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var e = 1 - Math.pow(1 - p, 3);
        el.textContent = d.pre + fmt(Math.round(d.target * e)) + d.post;
        if (p < 1) requestAnimationFrame(step); else el.textContent = d.full;
      }
      requestAnimationFrame(step);
    }
    if (hasIO) {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            var d = prepare(en.target);
            if (d) run(en.target, d);
            cio.unobserve(en.target);
          }
        });
      }, { threshold: 0.4 });
      counters.forEach(function (c) { cio.observe(c); });
    }
  }

  function boot() { document.querySelectorAll('.vs').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
